var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_924_35678)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 16.6917C17.5 9.19169 30.25 9.1921 34 16.6921C35.312 19.316 36.9299 22.965 38.4792 26.6007C41.4804 33.6436 37.279 41.6938 29.6914 42.7131C27.5499 43.0008 25.5456 43.1919 24 43.1919C22.5027 43.1919 20.575 43.0126 18.5091 42.7398C10.8513 41.7288 6.65991 33.5576 9.6941 26.4543C11.2264 22.8671 12.7919 19.2805 14 16.6917Z",
    fill: "none",
    stroke: "current",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 20.8586C21.2386 20.8586 19 22.3509 19 24.1919C19 26.0328 21.2386 27.5252 24 27.5252C26.7614 27.5252 29 29.0176 29 30.8585C29 32.6995 26.7614 34.1918 24 34.1918M24 20.8586C25.8507 20.8586 27.4665 21.5289 28.3311 22.5252M24 20.8586V19.1919M24 20.8586L24 34.1918M24 34.1918L24 35.8585M24 34.1918C22.1493 34.1918 20.5335 33.5215 19.6689 32.5252",
    fill: "none",
    stroke: "current",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6161 12.5755L11.5475 9.31352C11.0619 8.92419 11.0558 8.20416 11.5706 7.85443C13.3956 6.61479 17.7608 4.19174 24 4.19174C30.2528 4.19174 34.8271 6.62536 36.7485 7.86252C37.281 8.20534 37.2902 8.94172 36.7994 9.34187L32.3838 12.9417",
    fill: "none",
    stroke: "current",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_924_35678"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "none",
    stroke: "current"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeal);
export default __webpack_public_path__ + "static/media/deal.01d0f3831fa102129a8564b3cca2fc19.svg";
export { ForwardRef as ReactComponent };